

<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/miinteressa">AREE TEMATICHE</a></span></li>
            <li class="last"><span><a href="/sirang/energia">ENERGIA</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="aui-w70 portlet-column" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_Mb4WxUuPzNUc_">
                     <span id="p_56_INSTANCE_Mb4WxUuPzNUc"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_Mb4WxUuPzNUc">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Energia</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <p> Per la Tematica dell'<strong>Energia, </strong>in considerazione della complessità e della vastità dell'argomento, si rende necessaria la progettazione e la realizzazione di molteplici moduli applicativi, che di seguito vengono riassunti:</p>
                                       <ul>
                                          <li> BILANCIO ENERGETICO, gestisce le informazioni connesse al bilancio energetico ed in particolare alla produzione di energia, comprendendo i catasti relativi agli impianti per la produzione e distribuzione di energia (quali Impianti FER, FT, impianti di trasformazione fonti fossili e gli impianti di produzione di biomasse ), ed ai consumi energetici (domanda di energia), nonché le procedure per l'elaborazione del bilancio energetico stesso, compreso il catasto degli impianti di import, export e bunkeraggio di fonti energetiche</li>
                                          <li> SOSTENIBILITA' ENERGETICA, comprende la relativa sezione per l'accreditamento della certificazione energetica.</li>
                                          <li> &nbsp;IMPIANTI TERMICI, comprende il catasto degli impianti termici e la sezione dedicata alle comunicazioni.</li>
                                          <li> &nbsp;INQUINAMENTO LUMINOSO, comprende il catasto delle sorgenti di inquinamento luminoso e degli impianti di illuminazione a contenimento energetico e la sezione dedicata alle comunicazioni degli Osservatori astronomici</li>
                                       </ul>
                                    </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
            <div class="aui-w30 portlet-column portlet-column-last" id="column-2">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-2">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_ieAw63KB7TJL_">
                     <span id="p_56_INSTANCE_ieAw63KB7TJL"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_ieAw63KB7TJL">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">Dati ambientali</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <ul>
                                          <li> <a target="_blank" href="https://portal.sardegnasira.it/web/sardegnaambiente/dati-ambientali-energia">Vai alla pagina</a></li>
                                       </ul>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <form action="#" id="hrefFm" method="post" name="hrefFm"> <span></span> </form>
   </div>
</div>